import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./components/landing/Landing";
import Contactus from "./components/Contactus/Contactus";
import PrivacyPolicy from "./components/privacy/PrivacyPolicy";
import About from "./components/about/About";

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
            <Route path="/contact" element={<Contactus />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<About />} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;